export default {
  props: {
    uFileId: {
      type: [String, Number],
      default: ''
    },
    uName: {
      type: String,
      default: ''
    },
    uFilePath: {
      type: String,
      default: ''
    },
    uFileSize: {
      type: [String, Number],
      default: ''
    },
    uFileName: {
      type: String,
      default: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/uAttach/attachMixin.js